import type { ReactElement } from 'react'

import { Card, FloraButton, FloraLink, FloraTypography } from '@grupoboticario/flora-react'

import type { AccelerationContentFields } from '../../AccelerationForm.types'
import {
  descriptionTypographyCss,
  previewCardCss,
  rulesLinkCss,
  StyledCardActions,
  StyledCardContent,
  StyledCardImage,
  StyledCardImagePlaceholder,
  titleTypographyCss
} from './AcceleratorVisualPreview.styles'

interface AcceleratorVisualPreviewProps {
  values: Pick<AccelerationContentFields, 'title' | 'description' | 'imageUrl' | 'buttonText' | 'buttonUrl'>
  base64Image: string | null
}

const AcceleratorVisualPreview = ({ values, base64Image }: AcceleratorVisualPreviewProps) => {
  const imageAlt = values.title || 'Imagem do acelerador'

  let previewImage: ReactElement
  if (base64Image) {
    previewImage = <StyledCardImage src={base64Image} alt={imageAlt} />
  } else if (values.imageUrl) {
    previewImage = <StyledCardImage src={values.imageUrl} alt={imageAlt} />
  } else {
    previewImage = <StyledCardImagePlaceholder />
  }

  return (
    <Card css={previewCardCss}>
      {previewImage}
      <StyledCardContent>
        <FloraTypography fontSize="bodySmallShort" fontWeight="bold" css={titleTypographyCss}>
          {values.title || 'Título do acelerador'}
        </FloraTypography>
        <FloraTypography
          fontSize="bodySmallShort"
          fontWeight="regular"
          css={descriptionTypographyCss}
          dangerouslySetInnerHTML={{ __html: values.description || 'Breve descrição do acelerador' }}
        />
        <StyledCardActions>
          <FloraLink aria-label="Regras" as="button" css={rulesLinkCss} size="small" type="button">
            Regras
          </FloraLink>
          {values.buttonText && (
            <FloraButton hierarchy="primary" size="small" styleSemantic="neutral" type="button">
              {values.buttonText || 'Botão'}
            </FloraButton>
          )}
        </StyledCardActions>
      </StyledCardContent>
    </Card>
  )
}

export default AcceleratorVisualPreview
